import React, { ReactElement } from "react";

import { Stack } from "@mui/material";

import { ReduxTextField } from "../../../../components/Redux/TextField";
import {
  getRouteFormProperty,
  setIntegerRouteFormProperty,
  setRouteFormError,
  setRouteFormProperty,
} from "../../../../slices/routes";
import { validateInteger } from "../../../../validators/integer";
import InnerSetting from "./InnerSetting";

function validateStatus(data: string): string {
  const err = validateInteger(data);
  if (err) {
    return err;
  }

  if (data) {
    const status = parseInt(data);
    if (status < 200 || status >= 600) {
      return "must be at least 200 and less than 600";
    }
  }

  return "";
}

type ResponseBuilderProps = {
  readonly: boolean;
};
export const ResponseBuilder = ({
  readonly,
}: ResponseBuilderProps): ReactElement => {
  return (
    <Stack spacing={1}>
      <InnerSetting docsKey="response-status" label={"Status"}>
        <ReduxTextField
          disabled={readonly}
          fullWidth
          path="response.status"
          setter={setIntegerRouteFormProperty}
          getter={getRouteFormProperty}
          errorHandler={setRouteFormError}
          validator={validateStatus}
        />
      </InnerSetting>

      <InnerSetting docsKey="response-body" label={"Body"}>
        <ReduxTextField
          fullWidth
          disabled={readonly}
          path="response.body"
          setter={setRouteFormProperty}
          getter={getRouteFormProperty}
          errorHandler={setRouteFormError}
          multiline={true}
          rows={10}
        />
      </InnerSetting>
    </Stack>
  );
};
